export default __webpack_public_path__ + "static/swvl-2-f9d160a333d630ba350ff22cefa5952b.webp";